import { MovementIntentSystem } from '@common/systems/MovementIntentSystem';

import { ClientServiceContainer } from '../services/ClientServiceContainer';

/**
 * Client-specific implementation of MovementIntentSystem.
 *
 * This class exists to strictly limit the movement intent logic to the Local Player ONLY.
 * The default MovementIntentSystem runs for all entities if localPlayerOnly is false (server behavior),
 * or tries to run for local player if true. However, on the client, we need to explicitly provide
 * the Local Player's Entity ID so the system knows who that is.
 *
 * Prevents remote player velocities (synced from server) from being overwritten by local input logic.
 */
export class ClientMovementIntentSystem extends MovementIntentSystem {
  protected clientServices: ClientServiceContainer;
  protected override localPlayerOnly = true;

  constructor(clientServices: ClientServiceContainer) {
    super(clientServices.common);
    this.clientServices = clientServices;
  }

  protected override getLocalPlayerEntityId(): number | undefined {
    return this.clientServices.localPlayer.entityId;
  }
}
